var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showPopOut,
          expression: "showPopOut",
        },
      ],
      staticClass: "pop-out",
      on: {
        click: function ($event) {
          return _vm.hideNav()
        },
      },
    },
    [
      _c("transition", { attrs: { name: "slide-in-right" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showRightNav,
                expression: "showRightNav",
              },
            ],
            staticClass: "pop-out-side-bar",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("img", {
              staticClass: "close-menu-icon",
              attrs: { src: "/img/close-menu.svg" },
              on: {
                click: function ($event) {
                  return _vm.hideNav()
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "side-bar-link-logout" }, [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      return _vm.logout()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("auth.logoutButton")) +
                      "\n                "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.licensePlate
              ? _c(
                  "div",
                  { staticClass: "license-plate-container-mobile-view" },
                  [
                    _c("span", { staticClass: "license-plate-mobile-view" }, [
                      _vm._v(_vm._s(_vm.licensePlate)),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "language-switch-container-mobile-view" },
              [_c("lang-switcher")],
              1
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }